import ApiService from './api.service'
class handleError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const apiUrlDirectorio = '/directorio';

const DirectorioService = {

    save: async function (data) {
        try {
            const response = await ApiService.post(apiUrlDirectorio, data);
            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }

    },

    list: async function (page, data) {
        try {
            console.log('data: ', data);
            const response = await ApiService.post(`${apiUrlDirectorio}/${page}`, data);
            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            console.log(error);
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },

    edit: async function (data) {
        try {
            const response = await ApiService.put(apiUrlDirectorio, data);
            console.log(response);
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`${apiUrlDirectorio}/${id}`);
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },

    restore: async function (id) {
        try {
            const response = await ApiService.post(`${apiUrlDirectorio}/restore/${id}`);
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },
    get: async function (id){
        try {
          const response = await ApiService.get(`${apiUrlDirectorio}/${id}`)
          ApiService.mount401Interceptor()
          return response.data.success
        } catch (err) {
          throw new HandleError(err.response.status, err.response.data.detail)
        }
      }

}

export default DirectorioService

export { DirectorioService, handleError }